/**
 * Chat-related enums for type safety and consistency
 */

/**
 * Socket event types for chat messages
 */
export enum ChatSocketEvent {
  RECEIVE_MESSAGE = 'receiveMessage',
  MESSAGE_SENT = 'messageSent',
  CONVERSATION_EVENTS = 'conversationEvents',
}

/**
 * Conversation event types (typing indicators, etc.)
 */
export enum ConversationEventType {
  TYPING = 'typing',
  NOT_TYPING = 'notTyping',
}

/**
 * Message status for optimistic updates and error handling
 */
export enum MessageStatus {
  PENDING = 'pending',
  UPLOADING = 'uploading',
  COMPLETED = 'completed',
  SENDING = 'sending',
  SENT = 'sent',
  FAILED = 'failed',
}

/**
 * Message signal types (for special message types like typing indicators)
 */
export enum MessageSignal {
  TYPING = 'typing',
}

/**
 * Special message IDs used for synthetic messages
 */
export enum SpecialMessageId {
  TYPING = 'typing',
}
